import { tutoresApi, usuariosApi } from "../../services/api";
import { useLoading } from "../../utils/LoadingProvider";
import { toast } from 'react-toastify';
import React, { useMemo, useState } from 'react';
import { useDialog } from "../../components/Dialogs/Dialogprovider";

export const useUsuarioCreacionModel = () => {
    const {withLoading } = useLoading();
    const { showSuccess, showError, showConfirm } = useDialog();
    

    const [nuevoCliente, setNuevoCliente] = useState({
        nombreCompleto: '',
        correo: '',
        celular: '57',
        contrasena: '',
        confirmarContrasena: ''
    });

    //verificar para crear
    const verificarPreRegistro = async(clienteData) =>{
      return withLoading(async () =>{
        
        try{
            const contrasena = clienteData.contrasena;

            if (contrasena !== clienteData.confirmarContrasena) {
                toast.error("Error: Las contraseñas no coinciden");
                return false;  // Detiene la ejecución si las contraseñas no coinciden
            }

            const clienteJson = {
              ...clienteData,
              numero: parseInt(clienteData.numero, 10)
            };

            const respuesta = await usuariosApi.precreateUsuarioCliente(clienteJson,contrasena);

            console.log("respuesta",respuesta);
            
            if (!respuesta.valido) {
              toast.error(respuesta.error);
              return null;
            }

            return respuesta;

        }
        catch(error){
          console.error('Error al añadir prospecto:', error);
          toast.error("Error, " + error.response.data.error);
          return false;
        }
      
      },' Registrando cliente ');
    }

    //Enviar codigo de verificacion, por si no llega a llegar
    const enviarCodigoVerificacion = async(clienteData, esVerificado = false) =>{
      return withLoading(async () => {
        try{

        }
        catch(error){

        }
      },'Enviando codigo...');
    }

    //validar codigo y crear usuario
    const confirmarCodigoYCrearUsuario = async (identificador,codigoOTP,clienteData) =>{
      return withLoading(async () =>{
        try{
          const respuesta = await usuariosApi.verificarOtpyCrear(identificador,codigoOTP,clienteData);

          if(respuesta.success){
            toast.success(respuesta.message);
            showSuccess(respuesta.message);
            return true;
          }else{
            toast.error(respuesta.message);
            showError(respuesta.message);
            return false;
          }

        }
        catch(error){
          console.error("Error al verificar/crear:", error);
        const msg = error.response?.data?.message || "Error al crear la solicitud";
          toast.error(msg);
          return false;
        }
      }, 'Verificando y crenado cuenta...')
    }

    //generar enlace de cambio de contraseá
    const generateCambioContrasena = async(correoElectronico) => {

      return withLoading(async ()=>{

        try{
          const respuesta = await usuariosApi.generateCambioContrasena(correoElectronico);

          if(respuesta.success){
            toast.success(respuesta.message);
            showSuccess(respuesta.message);
            return true;
          }else{
            toast.error(respuesta.message);
            showError(respuesta.message);
            return false;
          }

        }
        catch(error){
          console.error("Error al verificar/crear:", error);
          const msg = error.response?.data?.message || "Error al crear la solicitud";
          toast.error(msg);
          return false;
        }

      },' Generando enlace para cambiar contraseña');

    }

    return{
       nuevoCliente,
       verificarPreRegistro,
       enviarCodigoVerificacion,
       confirmarCodigoYCrearUsuario,
       generateCambioContrasena
    }

}